import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { TextField } from '../../01_atoms/FormElements';
import Button from '../../01_atoms/Button';
import { currencySymbolPath } from '../../../utils/currency';
import { composeParsers } from '../../../utils/formFieldParsers';
import { composeValidators } from '../../../utils/formFieldValidators';

import styles from './index.module.scss';

const TextFieldButton = ({
  currency = null,
  buttonLabel,
  placeholder,
  onSubmit,
  inputParsers = [],
  inputValidators = null,
  withArrow = false,
  value = null,
  type = 'primary',
}) => {
  const id = useId();
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ amount: value }}
      subscription={{ submitting: true, valid: true }}
      render={({ handleSubmit, submitting, valid }) => (
        <form
          className={`text-field-button ${styles['text-field-button']}`}
          onSubmit={handleSubmit}
        >
          <TextField
            name="amount"
            placeholder={placeholder}
            color="white"
            icon={currencySymbolPath[currency]}
            parse={inputParsers && composeParsers(...inputParsers)}
            validate={inputValidators && composeValidators(...inputValidators)}
            // Enable numeric keyboard for mobile devices.
            inputMode="numeric"
            pattern="[0-9]+"
            infoOnPatternNotMatched="Please use numbers only"
            id={id}
          />

          <Button
            size="extra-large"
            isLoading={submitting}
            isDisabled={!valid}
            withArrow={valid && withArrow}
            type={type}
          >
            {buttonLabel}
          </Button>
        </form>
      )}
    />
  );
};

TextFieldButton.propTypes = {
  placeholder: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.number,
  type: PropTypes.string,
  currency: PropTypes.oneOf(['GBP', 'EUR']),
  inputValidators: PropTypes.arrayOf(PropTypes.func),
  inputParsers: PropTypes.arrayOf(PropTypes.func),
  withArrow: PropTypes.bool,
};

export default TextFieldButton;
